export default __webpack_public_path__ + "static/electronic_white_board_b.b12c8fb89d5cc56bbbe16931053004e5.png";